exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-container{width:300px}#Feb2020+.btn-label:before{content:\"\";width:100%;height:100%;position:absolute;top:0;left:100%;z-index:-1;background-color:rgba(255,106,0,.8);transition:all .3s ease;border-radius:15px}#Feb2020:checked+.btn-label:before{left:0}#Feb2020:checked+.btn-label,#Feb2022:checked+.btn-label{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a51878ac","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Forsakringskassan_VAB.vue
// module id = 660
// module chunks = 0